import { Bitcoin, BarChart3, Building2, Fuel, Globe2, Info } from "lucide-react";
import { TerminalShell } from "@/components/TerminalShell";
import { useLanguage } from "@/context/LanguageContext";

const card = "rounded-md border border-[#141A26] bg-[#0A0E16] p-6";

const MARKETS = [
  { key: "crypto", icon: Bitcoin },
  { key: "stocks", icon: Building2 },
  { key: "forex", icon: Globe2 },
  { key: "commodities", icon: Fuel },
  { key: "indices", icon: BarChart3 },
];

export default function InfoPage() {
  const { t } = useLanguage();

  const terms = [
    { label: t("positions.volume"), text: t("info.term1") },
    { label: t("trade.margin"), text: t("info.term2") },
    { label: t("metrics.equity"), text: t("info.term3") },
    { label: t("metrics.marginLevel"), text: t("info.term4") },
    { label: "P/L", text: t("info.term5") },
  ];

  return (
    <TerminalShell>
      <div data-testid="info-page" className="space-y-6 p-4 sm:p-8">
        <div>
          <h1 className="font-heading text-2xl font-light tracking-tight text-white">{t("info.title")}</h1>
          <p className="mt-1 text-sm text-[#8A97AD]">{t("info.subtitle")}</p>
        </div>

        <section className={card} data-testid="info-cfd">
          <p className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-[#5B9CFF]">
            <Info className="h-3.5 w-3.5" /> {t("info.cfdTitle")}
          </p>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-[#C7D0DE]">{t("info.cfdP1")}</p>
          <p className="mt-3 max-w-3xl text-sm leading-relaxed text-[#8A97AD]">{t("info.cfdP2")}</p>
        </section>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          {MARKETS.map((m) => (
            <section key={m.key} data-testid={`info-market-${m.key}`} className={card}>
              <m.icon className="h-4 w-4 text-[#5B9CFF]" />
              <h2 className="mt-4 text-base text-white md:text-lg">{t(`info.${m.key}`)}</h2>
              <p className="mt-2 text-sm leading-relaxed text-[#8A97AD]">{t(`info.${m.key}Text`)}</p>
            </section>
          ))}
        </div>

        <section className={card} data-testid="info-terms">
          <p className="text-[10px] uppercase tracking-[0.2em] text-[#5B9CFF]">{t("info.termsTitle")}</p>
          <ul className="mt-4 space-y-2 text-sm text-[#8A97AD]">
            {terms.map((term) => (
              <li key={term.label}>
                <span className="text-white">{term.label}</span> — {term.text}
              </li>
            ))}
          </ul>
        </section>
      </div>
    </TerminalShell>
  );
}
